// extracted by mini-css-extract-plugin
export default {"titleWrapper":"SectionTitle_titleWrapper__KpCAX"};